import React from 'react'
import PropTypes from 'prop-types'

const MessageTimelineIcon = (props) => {
  const { color = '#183560', classes = 'w-20' } = props
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 7.66667C23 8.85833 22.1 9.83333 21 9.83333C20.82 9.83333 20.65 9.81167 20.49 9.7575L16.93 13.6033C16.98 13.7767 17 13.9717 17 14.1667C17 15.3583 16.1 16.3333 15 16.3333C13.9 16.3333 13 15.3583 13 14.1667C13 13.9717 13.02 13.7767 13.07 13.6033L10.52 10.8408C10.36 10.895 10.18 10.9167 10 10.9167C9.82 10.9167 9.64 10.895 9.48 10.8408L4.93 15.7808C4.98 15.9542 5 16.1383 5 16.3333C5 17.525 4.1 18.5 3 18.5C1.9 18.5 1 17.525 1 16.3333C1 15.1417 1.9 14.1667 3 14.1667C3.18 14.1667 3.35 14.1883 3.51 14.2425L8.07 9.31333C8.02 9.14 8 8.945 8 8.75C8 7.55833 8.9 6.58333 10 6.58333C11.1 6.58333 12 7.55833 12 8.75C12 8.945 11.98 9.14 11.93 9.31333L14.48 12.0758C14.64 12.0217 14.82 12 15 12C15.18 12 15.36 12.0217 15.52 12.0758L19.07 8.21917C19.02 8.04583 19 7.86167 19 7.66667C19 6.475 19.9 5.5 21 5.5C22.1 5.5 23 6.475 23 7.66667Z"
        fill={color}
      />
    </svg>
  )
}

MessageTimelineIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(MessageTimelineIcon)
